import { Route } from 'react-router-dom';
import { IncentiveStatementDetails, IncentiveStatementSummary } from './incentives';
import { ListStatementsPage } from './list-statements';
import { RequireAuth, UseActiveClient } from '/src/components';

export { ListStatementsPage, IncentiveStatementDetails, IncentiveStatementSummary };

export const statementRoutes: React.ReactElement[] = [
  // Incentive Statement Summary
  <Route
    path="/clients/:client_id/statements/incentive/:incentive_statement_id"
    element={
      <RequireAuth>
        <UseActiveClient>
          <IncentiveStatementSummary />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Incentive Statement Details
  <Route
    path="/clients/:client_id/statements/incentive/:incentive_statement_id/details"
    element={
      <RequireAuth>
        <UseActiveClient>
          <IncentiveStatementDetails />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Incentive Statement Summary (Combined Programs)
  <Route
    path="/clients/:client_id/statements/reporting-period/:reporting_period_id"
    element={
      <RequireAuth>
        <UseActiveClient>
          <IncentiveStatementSummary />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Incentive Statement Details (Combined Programs)
  <Route
    path="/clients/:client_id/statements/reporting-period/:reporting_period_id/details"
    element={
      <RequireAuth>
        <UseActiveClient>
          <IncentiveStatementDetails />
        </UseActiveClient>
      </RequireAuth>
    }
  />,

  // Incentive Statements
  <Route
    path="/clients/:client_id/statements"
    element={
      <RequireAuth>
        <UseActiveClient>
          <ListStatementsPage />
        </UseActiveClient>
      </RequireAuth>
    }
  />,
];
